import { render, staticRenderFns } from "./DefaultRates.vue?vue&type=template&id=450445b2"
import script from "./DefaultRates.vue?vue&type=script&lang=js"
export * from "./DefaultRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports